// extracted by mini-css-extract-plugin
export default {"StudyGroupOption":"ChangeNmm_StudyGroupOption__dpgCW","SchoolOption":"ChangeNmm_SchoolOption__uyWp1","ChangeNmmMobile":"ChangeNmm_ChangeNmmMobile__wCfx5"};